import RichTextEditor, {
  RichTextEditorProps,
} from '@/components/richText/RichTextEditor.tsx';
import useTemplateImageSupport from '@/features/dashboard/templateImages/hooks/useTemplateImageSupport.ts';

type TemplateRichTextEditorProps = Omit<
  RichTextEditorProps,
  'imageSupport' | 'imagesLoading'
> & {
  // Wire the tenant media library (image toolbar + picker). Defaults to true;
  // pass false for a variable-only editor that skips fetching the library.
  withImages?: boolean;
};

// Feature-layer wrapper bundling the template-image data layer into
// `RichTextEditor`, so consumers don't prop-drill `imageSupport`/`imagesLoading`
// or call the hook themselves. Keeps the shared editor core decoupled from the
// feature hooks (the core never imports the data layer — see ARCHITECTURE.md).
const TemplateRichTextEditor = ({
  withImages = true,
  ...props
}: TemplateRichTextEditorProps) => {
  const { imageSupport, imagesLoading } = useTemplateImageSupport(withImages);

  return (
    <RichTextEditor
      {...props}
      imageSupport={withImages ? imageSupport : undefined}
      imagesLoading={withImages ? imagesLoading : undefined}
    />
  );
};

export default TemplateRichTextEditor;
